import dayjs from 'dayjs';
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '../../../theme';
import { ArrowUpRight, CaretRight,Info,ArrowDownLeft,ArrowsCounterClockwise, WarningCircle, CreditIcon,DebitIcon,ArrowUp,ArrowDown } from '@app/sharedComponents/Icons/Icons';
import { formatIndianCurrency } from '@app/utils/utility';
import { isFromTDLPlatform } from '@app/utils';

const TransactionOverview = ({onClick ,data,index,isfromTDL=false}) => {
  const {transactionType,transactionStatus,amount,description,settledOn,outStandingBalance,createdOn} = data
  const isTransactionCredit = transactionType === 'CREDIT';
  const isTransactionSettled = transactionStatus === "SETTLED";
  const isTransactionFailed = transactionStatus === "FAILED";
  const isTrasactionPending = transactionStatus === "PENDING_SETTLEMENT";
  const showOutStanding = transactionStatus === "SETTLED";
    return(
        <>
        {index>0 && <ThemedView width={'100%'} height={1} backgroundColor="border-secondary" />}
        <ThemedPressable onPress={()=>onClick(data)} py="lg" backgroundColor="bg-fill-primary">
        <ThemedView nativeId={index}  flexDirection='row' alignItems='center'>
            {
                 !isfromTDL && (isTransactionCredit ? <CreditIcon /> : <DebitIcon  />)
            }
            {
                isfromTDL &&(isTransactionCredit ? <ArrowUp size={16} weight="thin" /> : <ArrowDown size={16} weight="thin" />)
            }
                <ThemedView ml='md' flex={1}>
                    <ThemedView  alignItems='center' justifyContent='space-between' flexDirection='row' mb="xs" flex={1}>
                    <ThemedText variant='b3s' color='text-primary'>{description}</ThemedText>
                    <ThemedView flexDirection='row' alignItems='center'>
                        <ThemedText mr='xs' variant='b3m' color={ isTransactionFailed ? 'text-disabled':isTransactionCredit ?'text-success' :'text-primary'} >{isTransactionCredit ? '+':'-'} ₹{formatIndianCurrency(amount)}</ThemedText>
                        <CaretRight size={15} color={themeColorSet['icon-primary']} />
                    </ThemedView>
                    </ThemedView>
                    <ThemedView  justifyContent='space-between' flexDirection='row'>
                    <ThemedText variant='b4r' color='text-secondary'>{dayjs(isTrasactionPending ?createdOn : settledOn).format('DD MMM')}</ThemedText>
                    { isTransactionFailed &&
                    <ThemedView flexDirection='row' alignItems='center' mr="xl" mt="xs">
                        <WarningCircle size="14"  weight="fill"  fill={themeColorSet['icon-error']} />
                        <ThemedText variant='b4r' color='text-error' ml="xs">Failed</ThemedText>
                    </ThemedView>}
                    { isTrasactionPending &&
                    <ThemedView flexDirection='row' alignItems='center' mr="xl" mt="xs">
                        <ThemedView backgroundColor='icon-warning' width={14} height={14} borderRadius='full' justifyContent='center' alignItems='center' style={{ transform: [{ rotate: '90deg' }] }} >
                        <ArrowsCounterClockwise size="10" color="#fff" weight="thin" />
                        </ThemedView>
                        <ThemedText variant='b4r' color='text-warning' ml="xs">Processing</ThemedText>
                    </ThemedView>}
                    </ThemedView>
                </ThemedView>
        </ThemedView>
        {showOutStanding && <ThemedText variant='b4r' color='text-secondary' ml="7xl" mt="xs">Outstanding: ₹ {formatIndianCurrency(outStandingBalance)}</ThemedText>}

        </ThemedPressable>
        </>
    )
}
export default TransactionOverview;